import { Injectable } from "@angular/core";
import { DashboardApi } from "../api/dashboard.api";
import { Observable } from "rxjs";

@Injectable()
export class DashboardService {

  constructor(private _api: DashboardApi) {
  }
  getInadimplenciaBI(): Promise<any> {
    return new Promise<any>((resolver, reject) => {
      this._api.doGet(`inadimplencia`, {})
        .subscribe((res) => {
          resolver(res)
        }, (error) => reject(error));
    });
  }
  getCsvInadimplenciaBI(): Promise<any> {
    return new Promise<any>((resolver, reject) => {
      this._api.doGet(`inadimplencia/csv`, { observe: 'response', responseType: "blob" })
        .subscribe((res) => {
          this.saveFile(res.body, "inadimplencia.csv", false);
          resolver(res)
        }, (error) => reject(error));
    });
  }

  getFaturamentoBI(dataBase: Date, dataBaseFinal: Date): Promise<any> {
    return new Promise<any>((resolver, reject) => {
      this._api.doGet(`faturamento`, { params: { dataBase: dataBase.toISOString(), dataBaseFinal: dataBaseFinal.toISOString() } })
        .subscribe((res) => {
          resolver(res)
        }, (error) => reject(error));
    });
  }
  getCsvFaturamentoBI(dataBase: Date, dataBaseFinal: Date): Promise<any> {
    return new Promise<any>((resolver, reject) => {
      this._api.doGet(`faturamento/csv`, { params: { dataBase: dataBase.toISOString(), dataBaseFinal: dataBaseFinal.toISOString() }, observe: 'response', responseType: "blob" })
        .subscribe((res) => {
          this.saveFile(res.body, "faturamento.csv", false);
          resolver(res)
        }, (error) => reject(error));
    });
  }

  getDevolucoesBI(dataBase: Date, dataBaseFinal: Date): Promise<any> {
    return new Promise<any>((resolver, reject) => {
      this._api.doGet(`devolucoes`, { params: { dataBase: dataBase.toISOString(), dataBaseFinal: dataBaseFinal.toISOString() } })
        .subscribe((res) => {
          resolver(res)
        }, (error) => reject(error));
    });
  }
  getCsvDevolucoesBI(dataBase: Date, dataBaseFinal: Date): Promise<any> {
    return new Promise<any>((resolver, reject) => {
      this._api.doGet(`devolucoes/csv`, { params: { dataBase: dataBase.toISOString(), dataBaseFinal: dataBaseFinal.toISOString() }, observe: 'response', responseType: "blob" })
        .subscribe((res) => {
          this.saveFile(res.body, "devolucoes.csv", false);
          resolver(res)
        }, (error) => reject(error));
    });
  }

  getQuantidadesBI(dataBase: Date, dataBaseFinal: Date): Promise<any> {
    return new Promise<any>((resolver, reject) => {
      this._api.doGet(`quantidades`, { params: { dataBase: dataBase.toISOString(), dataBaseFinal: dataBaseFinal.toISOString() } })
        .subscribe((res) => {
          resolver(res)
        }, (error) => reject(error));
    });
  }
  getCsvQuantidadesBI(dataBase: Date, dataBaseFinal: Date): Promise<any> {
    return new Promise<any>((resolver, reject) => {
      this._api.doGet(`quantidades/csv`, { params: { dataBase: dataBase.toISOString(), dataBaseFinal: dataBaseFinal.toISOString() }, observe: 'response', responseType: "blob" })
        .subscribe((res) => {
          this.saveFile(res.body, "quantidades.csv", false);
          resolver(res)
        }, (error) => reject(error));
    });
  }

  getRecebimentosBI(dataBase: Date, dataBaseFinal: Date): Promise<any> {
    return new Promise<any>((resolver, reject) => {
      this._api.doGet(`recebimentos`, { params: { dataBase: dataBase.toISOString(), dataBaseFinal: dataBaseFinal.toISOString() } })
        .subscribe((res) => {
          resolver(res)
        }, (error) => reject(error));
    });
  }
  getCsvRecebimentosBI(dataBase: Date, dataBaseFinal: Date): Promise<any> {
    return new Promise<any>((resolver, reject) => {
      this._api.doGet(`recebimentos/csv`, { params: { dataBase: dataBase.toISOString(), dataBaseFinal: dataBaseFinal.toISOString() }, observe: 'response', responseType: "blob" })
        .subscribe((res) => {
          this.saveFile(res.body, "recebimentos.csv", false);
          resolver(res)
        }, (error) => reject(error));
    });
  }


  public prepararDadosDeFaturamentoParaGrafico(data: any): { porAno: any[], porTrimestre: any[], porMes: any[] } {
    const visaoAno = {};
    const visaoTrimestre = {};
    const visaoMes = {};

    const faturamentos = data.Faturamentos || [];

    faturamentos.forEach((item: any) => {
      // 1. Calcular totais da nota atual
      const totalNota = item.Produtos.reduce((acc: number, prod: any) => acc + prod.Total, 0);
      const qtdProdutos = item.Produtos.reduce((acc: number, prod: any) => acc + prod.Quantidade, 0);

      // 2. Tratar e extrair partes da data
      // Aceita formato 'YYYY-MM-DD' ou ISO string
      const dataEmissao = new Date(item.EmissaoFormatted || item.Emissao);
      const ano = dataEmissao.getFullYear();
      const mesNumero = dataEmissao.getMonth() + 1; // getMonth() é base 0
      const mesFormatado = String(mesNumero).padStart(2, '0');

      // Cálculo do trimestre (1 a 4)
      const trimestre = Math.ceil(mesNumero / 3);

      // Chaves de agrupamento
      const chaveAno = `${ano}`;
      const chaveTrimestre = `${ano}-Q${trimestre}`;
      const chaveMes = `${ano}-${mesFormatado}`;

      // Helper para acumular os valores
      const acumular = (objeto: any, chave: any, rotulo: any) => {
        if (!objeto[chave]) {
          objeto[chave] = {
            periodo: chave,
            rotulo: rotulo,
            totalFaturamento: 0,
            quantidadeProdutos: 0,
            totalNotas: 0,
          };
        }
        objeto[chave].totalFaturamento += totalNota;
        objeto[chave].quantidadeProdutos += qtdProdutos;
        objeto[chave].totalNotas += 1;
      };

      acumular(visaoAno, chaveAno, `${ano}`);
      acumular(visaoTrimestre, chaveTrimestre, `${trimestre}º Trimestre / ${ano}`);
      acumular(visaoMes, chaveMes, `${mesFormatado}/${ano}`);
    });

    // Converte os objetos em arrays ordenados para os gráficos
    return {
      porAno: Object.values(visaoAno).sort((a:any, b:any) => a.periodo.localeCompare(b.periodo)),
      porTrimestre: Object.values(visaoTrimestre).sort((a:any, b:any) => a.periodo.localeCompare(b.periodo)),
      porMes: Object.values(visaoMes).sort((a:any, b:any) => a.periodo.localeCompare(b.periodo)),
    };
  }

  public saveFile(blob: Blob, fileName: string, open: boolean = true) {
    if (blob) {
      const url = window.URL.createObjectURL(blob);
      if (open)
        window.open(url);
      const link = document.createElement("a");
      link.href = url;
      link.download = "PortalREP-" + fileName;
      link.click();
    }
  }

}